import type { IconSvgObject } from './types';

const CalendarHeartIcon: IconSvgObject = [
  ["path", { d: "M16 2V6M7 2V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 11V6C20.5 4.89543 19.6046 4 18.5 4H4.5C3.39543 4 2.5 4.89543 2.5 6V20C2.5 21.1046 3.39543 22 4.5 22H11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 10H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17.5 22C17.5 22 13.5 19.5294 13.5 17.1389C13.5 15.9576 14.3421 15 15.5 15C16.1 15 16.7 15.2059 17.5 16.0294C18.3 15.2059 18.9 15 19.5 15C20.6579 15 21.5 15.9576 21.5 17.1389C21.5 19.5294 17.5 22 17.5 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CalendarHeartIcon;
